import {Bar} from "react-chartjs-2";
import React from "react";
import _ from 'lodash';

const MovementScore = props => {
  const movementScores = props.graphData.datasets[0].data.map(parseFloat);
  const averageWeeklyMovementScore = _.meanBy(movementScores);
  const graphOptions = {
    indexAxis: 'y',
    plugins: {
      tooltip: {
        enabled: true,
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart - Stacked',
      },
      legend: {
        display: false
      }
    },
    responsive: true,
    scales: {
      x: {
        ticks: {
          beginAtZero: true,
          fontFamily: "'Open Sans Bold', sans-serif",
          fontSize: 11,
        },
        stacked: true,
      },
      y: {
        gridLines: {
          display: false,
          color: "#fff",
          zeroLineColor: "#fff",
          zeroLineWidth: 0
        },
        ticks: {
          fontFamily: "'Open Sans Bold', sans-serif",
          fontSize: 11
        },
        stacked: true,
      },
    },
  };

  return (
    <>
      <div className='sleep-chart'>
        <Bar height={'370'} width={'367'} options={graphOptions} data={props.graphData}/>
      </div>
      <hr/>
      <article className="clock-display">
        <div className='label'>
          Average Movement Score
        </div>
        <div className='value'>
          <strong className='time'>
            {averageWeeklyMovementScore ? averageWeeklyMovementScore.toFixed(1) : 0}
          </strong>
        </div>
      </article>
    </>
  )
}

MovementScore.defaultProps = {
  graphData: {}
}

export default MovementScore;
